export const Accordion = {
    init() {
        // set heights
        Accordion.setHeights();
        $(window).on('resize load', Accordion.setHeights);

        Accordion.bindEvents();

        if($('body').hasClass('floorplans-page')) {
            Accordion.setActivePanel();
        }
        
        $('body.legal .accordion table').scroltable();
    },

    updateInteractiveElements(content, isHidden) {
        // Update interactive elements inside the content
        const interactiveSelector = 'a, button, input, select, textarea, [tabindex], .prose';
        const elements = content.find(interactiveSelector);

        if (isHidden) {
            elements.attr('aria-hidden', 'true').attr('tabindex', '-1');
        } else {
            elements.removeAttr('aria-hidden').attr('tabindex', '0');
        }
    },

    setHeights() {
        $('.panel__content').each(function () {
            const panel = $(this).parents('.panel');
            const content = $(this);

            $(this).css({ height: 'auto' });
            $(this).attr('data-height', $(this).height());

            if (panel.hasClass('active')) {
                // $(this).css({ height: 'auto' });

                // content
                //     .css({ height: 'auto' })
                //     .removeAttr('aria-hidden')
                //     .removeAttr('tabindex');
                // content.find('p').removeAttr('aria-hidden');
                // content.find('p a').removeAttr('tabindex');
                // panel.find('.panel__title').attr('aria-expanded', 'true');

                content.css({ height: 'auto' }).removeAttr('aria-hidden').removeAttr('tabindex');
                Accordion.updateInteractiveElements(content, false);
                panel.find('.panel__title').attr('aria-expanded', 'true');

            } else {
                content.css({ height: 0 }).attr('aria-hidden', 'true').attr('tabindex', '-1');
                Accordion.updateInteractiveElements(content, true);
                panel.find('.panel__title').attr('aria-expanded', 'false');
            }
        });
    },
    bindEvents() {
        $('.panel__title').on('click', function (e) {
            e.preventDefault();
            var panel = $(this).parents('.panel');
            var accordion = $(panel).parents('.accordion');
            if (panel.hasClass('active')) {
                panel.removeClass('active');
                const content = panel.find('.panel__content');
                content.css({ height: 0 }).attr('aria-hidden', 'true').attr('tabindex', '-1');
                Accordion.updateInteractiveElements(content, true);
                $(this).attr('aria-expanded', 'false');
            } else {
                panel.addClass('active');
                setTimeout(() => {
                    $('html, body').animate(
                        {
                            scrollTop: $('.panel.active').offset().top,
                        },
                        500
                    );
                }, 200);

                const content = panel.find('.panel__content');
                const _h = content.attr('data-height');

                // $('.panel__content', panel).css({ height: _h });

                content.css({ height: _h }).removeAttr('aria-hidden').removeAttr('tabindex');
                Accordion.updateInteractiveElements(content, false);
                $(this).attr('aria-expanded', 'true');


                if (accordion.hasClass('unit-listing')) {
                    // panel
                    //     .siblings()
                    //     .removeClass('active')
                    //     .find('.panel__content')
                    //     .css({ height: 0 });
                } else {
                    // panel
                    //     .siblings()
                    //     .removeClass('active')
                    //     .find('.panel__content')
                    //     .css({ height: 0 });
                    panel
                    .siblings()
                    .removeClass('active')
                    .find('.panel__content')
                    .css({ height: 0 })
                    .attr('aria-hidden', 'true')
                    .attr('tabindex', '-1')
                    .end()
                    .find('.panel__title')
                    .attr('aria-expanded', 'false')
                    .end()
                    .find('.panel__content')
                    .each(function () {
                        Accordion.updateInteractiveElements($(this), true);
                    });
                }
            }
        });
        $('.panel__title').on('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault(); // Prevent page scrolling when Space is pressed
                $(this).click();
            }
        });
    },
    setActivePanel() {
        var accordion = $('.accordion'),
        panels = accordion.find('.panel')
        if (accordion.hasClass('unit-listing')) {
            panels.first().addClass('active')
            const content = panels.first().children('.panel__content'),
            _h = content.attr('data-height');

            content.css({ height: _h }).removeAttr('aria-hidden').removeAttr('tabindex');
            Accordion.updateInteractiveElements(content, false);
            
        }
    }
};
